import { cn } from '@/lib/utils'
import { useTranslation } from 'react-i18next'
import type { AudienceMetadataFormProps } from '@/types/components/audiences/review-form'

export const DEFAULT_TITLE_FONT = 'Oswald' as const

export const TITLE_FONT_OPTIONS = [
  { value: 'Agbalumo', label: 'Agbalumo' },
  { value: 'Agdasima', label: 'Agdasima' },
  { value: 'Aguafina Script', label: 'Aguafina Script' },
  { value: 'Alumni Sans Collegiate One', label: 'Alumni Sans' },
  { value: 'Annie Use Your Telescope', label: 'Annie Use Your Telescope' },
  { value: 'Anta', label: 'Anta' },
  { value: 'Anton SC', label: 'Anton SC' },
  { value: 'Bangers', label: 'Bangers' },
  { value: 'Bebas Neue', label: 'Bebas Neue' },
  { value: 'Bhavuka', label: 'Bhavuka' },
  { value: 'Briem Hand', label: 'Briem Hand' },
  { value: 'DM Sans', label: 'DM Sans' },
  { value: 'DM Serif Display', label: 'DM Serif' },
  { value: 'Geist Mono', label: 'Geist Mono' },
  { value: 'Gochi Hand', label: 'Gochi Hand' },
  { value: 'Inter', label: 'Inter' },
  { value: 'Montserrat', label: 'Montserrat' },
  { value: 'Oswald', label: 'Oswald' },
  { value: 'Pixelify Sans', label: 'Pixelify Sans' },
  { value: 'Roboto Condensed', label: 'Roboto Condensed' },
  { value: 'Sumana', label: 'Sumana' },
] as const

const fieldLabel = 'text-sm leading-[1.5] text-muted-foreground'
const fieldInput = cn(
  'flex h-[38px] w-full items-center rounded-[6px] border border-border',
  'bg-transparent px-2 py-2 text-base text-foreground',
  'placeholder:text-muted-foreground',
  'focus:outline-none focus:ring-1 focus:ring-ring',
  'disabled:cursor-not-allowed disabled:opacity-50',
  'transition-colors',
)

export function AudienceMetadataForm({
  values,
  initialValues,
  onChange,
  className,
}: AudienceMetadataFormProps) {
  const { t } = useTranslation('app')
  const isNameEmpty = values.name.trim() === ''
  return (
    <div className={cn('flex flex-col gap-4', className)}>
      <div className="flex flex-col gap-1">
        <label htmlFor="audience-name" className={fieldLabel}>
          {t('audienceCreate.name')}
        </label>
        <input
          id="audience-name"
          type="text"
          value={values.name}
          onChange={(e) => onChange('name', e.target.value)}
          maxLength={255}
          aria-invalid={isNameEmpty}
          aria-describedby={isNameEmpty ? 'audience-name-error' : undefined}
          className={fieldInput}
          style={{ outline: 'none', boxShadow: 'none' }}
        />
        {isNameEmpty && (
          <p id="audience-name-error" role="alert" className="text-xs text-destructive">
            {t('audienceCreate.nameEmpty')}
          </p>
        )}
      </div>

    </div>
  )
}
